<template>
<div id="tst">
        <v-tooltip bottom> 
            <v-chip
                        class="vinculoChip"
                        small
                        color="blue"
                        text-color="white"
                        @click="dialog = !dialog"
                        slot="activator"
                    >
                      CC-e
            </v-chip>
            <span>Visualizar Carta de Correção vinculada a esta nota</span>
          </v-tooltip> 
                    <v-dialog @keydown.esc="dialog = false"
                    v-model="dialog"
                    
                    fullscreen
                    :lazy="true"
                    >
                        <v-card>
                            <v-card-title
                            class="headline darkBlue text-xs-center"
                            text-color="white"
                            style="color: white;"
                            primary-title
                            
                            >
                            Cc-e Vinculadas
                            <v-spacer></v-spacer>
                            <div id="listaNfe" v-if="nota.item.xmlCce.length > 0">
                              <span>Cc-e Vinculadas</span>
                              <ol>
                                <li v-for="(chave,i) in nota.item.xmlCce" :key="i" @click="getCce(nota.item._id,i)">
                                  <h6>
                                    Cce
                                  </h6>
                                </li>
                              </ol>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click.native="dialog = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                            </v-card-title>

                            <v-card-text id="bodyNFeVinculada">
                              <h2 v-if="nota.item.xmlCce.length > 0" class="text-xs-center">{{text_info}}</h2>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                flat
                                @click="dialog = false"
                            >
                                Fechar
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
    </div>

</template>
<script>
import NfeService from "@/domain/notas/nfe/NfeService";
export default {
  props: ["nota"],
  data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "Clique na Cce para exibi-lá"
    };
  },
  watch: {
    dialog: function(newV, oldV) {
      if (newV) {
      
        this.getCce(this.nota.item._id, 0);
      }
    }
  },
  computed: {},
  methods: {
    getCce: async function(id, indice) {
    
      this.service = new NfeService(this.$http);
      await this.service.getDacce(id, indice).then(function(dacce) {
        this.danfeB64 = dacce;
        this.setPdfData();
      });
    },
    setPdfData: function() {
      if (this.danfeB64) {
        this.text_info = "";
        if (document.getElementById("pdf")) {
          document.getElementById("pdf").remove();
        }
        var embed = document.createElement("EMBED");
        embed.setAttribute(
          "src",
          "data:application/pdf;base64," + encodeURIComponent(this.danfeB64)
        );
        embed.setAttribute("id", "pdf");
        document.querySelector("#bodyNFeVinculada").appendChild(embed);
      } else {
        this.text_info =
          "Cce não encontrada em nosso sistema, disponivel somente em consulta individual no sefaz";
      }
    }
  }
};
</script>
<style>
/* #tst {
  display: inline-block;
} */
#lista {
  padding: 20px;
}
#pdf {
  width: 100%;
  height: 100vh;
}
#ico {
  color: grey !important;
  transition: color 1 linear;
}
#ico:hover {
  color: #01579b !important;
}
#ico.v-btn {
  margin: 2px 2px !important;
}
/* padding: 0px 6px 0px 5px; */
.vinculoChip span.v-chip__content {
  cursor: pointer;
  font-size: 10px !important;
  padding: 0px 6px 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_vinculo/btnCCeVinculadas/BtnCCeVinculadas.vue